<template>
  <div data-testid="document-management-send-control-root-page">
    <router-view />
  </div>
</template>
